<template>
  <div
    class="empty-list"
    :class="blockModifiersClasses"
  >
    <template
      v-if="!loading"
    >
      <span class="far fa-times-circle empty-list__icon" />
      <span class="empty-list__label" v-html="emptyMessageToShow"></span>
      <span class="empty-list__description" v-html="emptyDescription"></span>
    </template>
    <s-loader
      v-else
      class="empty-list__loader"
    />
  </div>
</template>

<script>
/**
 * Modelo de exibição para listagens vazias.
 *
 * Possui suporte a exibir carregador.
 */
export default {
  props: {
    // Opcional. Exibe o carregador ao invés da mensagem de lista vazia.
    loading: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },
    // Opcional. Sobrescreve a mensagem de lista vazia.
    emptyMessage: {
      type: String,
      required: false,
    },
    // Opcional. Sobrescreve a mensagem de lista vazia.
    emptyDescription: {
      type: String,
      required: false,
    },
    // Opcional. Remove os paddings da mensagem, deixando-a unida ao conteúdo acima e abaixo.
    noPadding: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    emptyMessageToShow() {
      return this.emptyMessage || this.$t('general.empty-list');
    },
    blockModifiersClasses() {
      return {
        'empty-list_no-padding': this.noPadding,
      };
    },
  },
};
</script>

<style  lang="sass" scoped>
.empty-list
  text-align: center
  opacity: 0.8
  &:not(&_no-padding)
    padding-top: 6rem
    padding-bottom: 6rem
  > *
    display: block
  &__icon,
  &__loader
    font-size: 3rem
  &__label
    margin-top: 1rem
    font-weight: bold
</style>
